module.exports = __webpack_public_path__ + "img/open.e08397b7.svg";